import React, { useState } from 'react';
import { api } from '../api.js';
import { Download, Upload } from 'lucide-react';
import { useT } from '../i18n/useT.js';
import { useAlert } from '../components/AlertProvider.jsx';

export default function SettingsPage() {
  const t = useT();
  const { showAlert } = useAlert();
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState(null);

  const handleExport = async () => {
    try {
      const res = await api.exportAll();
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'aic-export.zip';
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      showAlert(err.message, { tone: 'error', title: t('billing.loadFailed', 'Failed') });
    }
  };

  const handleImport = async () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.zip';
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      setImporting(true);
      try {
        const fd = new FormData();
        fd.append('file', file);
        const res = await api.importBundle(fd);
        setImportResult(res);
      } catch (err) {
        showAlert(err.message, { tone: 'error', title: t('billing.loadFailed', 'Failed') });
      } finally {
        setImporting(false);
      }
    };
    input.click();
  };

  return (
    <>
      <div className="toolbar"><h2>{t('settings.title', 'Settings')}</h2></div>
      <div className="page-content">
        <div className="card" style={{ maxWidth: 600, marginBottom: 16 }}>
          <h3 style={{ marginBottom: 12 }}>{t('settings.importExport', 'Import / Export')}</h3>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 16, fontSize: 14 }}>
            {t('settings.importExportText', 'Export all templates, assets, scripts, folders, and tags as a ZIP bundle, or import from a previously exported bundle.')}
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn-primary" onClick={handleExport}>
              <Download size={14} style={{ marginRight: 4 }} /> {t('settings.exportAll', 'Export All')}
            </button>
            <button className="btn-secondary" onClick={handleImport} disabled={importing}>
              <Upload size={14} style={{ marginRight: 4 }} /> {importing ? t('settings.importing', 'Importing...') : t('settings.importBundle', 'Import Bundle')}
            </button>
          </div>
          {importResult && (
            <div style={{ marginTop: 12, fontSize: 13, color: 'var(--success)' }}>
              {t('settings.imported', 'Imported: {{templates}} templates, {{assets}} assets, {{scripts}} scripts', {
                templates: importResult.imported?.templates || 0,
                assets: importResult.imported?.assets || 0,
                scripts: importResult.imported?.scripts || 0,
              })}
            </div>
          )}
        </div>

        <div className="card" style={{ maxWidth: 600 }}>
          <h3 style={{ marginBottom: 12 }}>{t('settings.about', 'About')}</h3>
          <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>
            {t('settings.aboutText', 'Report Engine v0.1.0 – Reporting server platform')}
          </p>
        </div>
      </div>
    </>
  );
}
